import { useEffect, useState } from "react"
import { getEmpleadoById,patchEmpleado,postEmpleado } from "../../services/EmpleadosServices"
import { EmpleadosFormContext } from "./EmpleadosContext"
import { useNavigate, useParams } from 'react-router-dom';

export const EmpleadosFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getEmpleadoByIdData(id)
    }, [])

    const getEmpleadoByIdData = async (id) => {
        let res = await getEmpleadoById(id)
        if (res) setReport(res)
    }

    const postEmpleadoData = async (body) => {
        const res = await postEmpleado(body)
        if (res) navigate("/Empleados");
    }

    const patchEmpleadoData = async (id, body) => {
        const res = await patchEmpleado(id, body)
        if (res) navigate("/Empleados");
    }

    return <EmpleadosFormContext.Provider value={{
        report,
        postEmpleadoData,
        patchEmpleadoData,
    }} >
        {children}
    </EmpleadosFormContext.Provider>
}